import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import more from 'highcharts/highcharts-more'
import { langGlobalStats } from '../assets/langGlobalStats.js'
import { useLang } from '../utils/hooks.jsx'

more(Highcharts)

const StatsCalendar = ({ data }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langGlobalStats.fr : langGlobalStats.eng
  const chartOptions = {
    chart: {
      type: 'bubble',
      /* backgroundColor: '#2F4F4F', */
      backgroundColor: 'white',
      zoomType: 'xy',
    },

    title: {
      text: choosenLang.calendarTitle,
      style: {
        fontSize: '12px',
        color: 'black',
      },
    },
    legend: {
      layout: 'vertical',
      align: 'left',
      verticalAlign: 'top',
      x: 25,
      y: 70,
      floating: false,
      backgroundColor: '#7788FF',
      borderWidth: 0,
      enabled: true,
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '9px',
        color: '#F8F8FF',
      },
      itemMarginTop: 3,
      itemMarginBottom: 3,
      reversed: true,
      symbolHeight: 0,
      symbolWidth: 0,
      symbolRadius: 0,
    },

    yAxis: {
      title: {
        text: choosenLang.calendarY,
      },
      gridLineWidth: 0,
      labels: {
        style: {
          fontSize: '9px',
          color: 'black',
        },
      },
    },
    xAxis: {
      lineColor: '#FFFFFF',
      labels: {
        style: {
          fontSize: '9px',
          color: 'black',
        },
      },
      gridLineWidth: 0,
      lineWidth: 0,

      title: {
        text: choosenLang.calendarX,
        style: {
          color: 'black',
        },
      },
      crosshair: {
        width: 1,
        color: 'green',
        snap: false,
      },
    },
    tooltip: {
      pointFormat:
        '{point.options.custom.type_sport}<br />{point.options.custom.date}<br />{point.options.custom.duree}<br />{point.options.custom.nb}',
    },

    plotOptions: {
      bubble: {
        minSize: 2,
        maxSize: 30,
      },
    },
    series: data,
  }

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />
}

export default StatsCalendar
